var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWoswo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13104 -1656)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-13104 1656)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13099 1661.431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530.135-403c2.938,0,5.877-.007,8.815,0a3.564,3.564,0,0,1,3.525,2.38,4.239,4.239,0,0,1,.22,1.371c.014,5.843,0,11.687.016,17.53a3.694,3.694,0,0,1-3.777,3.85c-5.927-.015-11.854.012-17.781-.014a3.563,3.563,0,0,1-3.618-3.724q0-8.815,0-17.63a3.586,3.586,0,0,1,3.734-3.762C524.225-403.007,527.18-403,530.135-403Zm9.932,12.646q0-4.383,0-8.766c0-.892-.28-1.19-1.162-1.191q-8.766-.008-17.533,0c-.934,0-1.224.31-1.224,1.241q0,8.691,0,17.383c0,1.007.27,1.288,1.269,1.288q8.716,0,17.433,0c.93,0,1.216-.3,1.217-1.238Q540.069-385.992,540.068-390.35Z",
    transform: "translate(-517.535 403)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.594-264.938c1.453,0,2.906-.022,4.358.012.5.011.62-.16.608-.626-.023-.917.272-1.367.938-1.57a1.278,1.278,0,0,1,1.666,1.1c.038.348-.008.82.194,1s.664.073,1.013.076c.888.009,1.4.408,1.481,1.16a1.253,1.253,0,0,1-1.19,1.44c-.349.027-.7.019-1.051.011-.318-.007-.451.132-.45.45a3.334,3.334,0,0,1-.07.89,1.251,1.251,0,0,1-1.232.919A1.3,1.3,0,0,1,573.6-261.1a1.686,1.686,0,0,1-.035-.2c-.137-1.035-.137-1.035-1.173-1.035q-4.083,0-8.165,0a1.267,1.267,0,0,1-1.41-.943,1.265,1.265,0,0,1,1.267-1.661C565.589-264.948,567.091-264.937,568.594-264.938Z",
    transform: "translate(-558.231 280.791)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.351-352.175q-1.852,0-3.7,0c-.8,0-.777-.078-.776.743a1.38,1.38,0,0,1-.6,1.3,1.289,1.289,0,0,1-1.99-.953c-.049-.341.02-.853-.171-.982-.27-.183-.731-.087-1.111-.1-.416-.017-.837.009-1.248-.043a1.222,1.222,0,0,1-1.091-1.234,1.151,1.151,0,0,1,.981-1.255,12.256,12.256,0,0,1,1.99-.1c.438.006.67-.09.616-.579a2.167,2.167,0,0,1,.052-.6,1.18,1.18,0,0,1,1.167-1.033,1.167,1.167,0,0,1,1.326.948,2.131,2.131,0,0,1,.077.689c-.041.437.109.574.557.57,2.3-.022,4.6-.016,6.906-.005a8.711,8.711,0,0,1,1.489.106,1.131,1.131,0,0,1,.945,1.181,1.182,1.182,0,0,1-.92,1.259,2.8,2.8,0,0,1-.69.082C575.887-352.171,574.619-352.175,573.351-352.175Z",
    transform: "translate(-558.135 361.618)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoswo);
export default __webpack_public_path__ + "static/media/woswo.95a8dd42.svg";
export { ForwardRef as ReactComponent };